<ng-container *transloco="let t; read: 'RESTAURANT_DESCRIPTION_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
      <div class="spacer"></div>
    </div>
  </ion-toolbar>
  <ion-content class="ion-padding">
    <div class="content px-32-desktop">
      <h2>{{ t('TITLE') }}</h2>
      <div *ngIf="restaurant?.description" class="inline-img" [innerHTML]="restaurant!.description! | trustHtml"></div>
      <div class="spacer hide-if-desktop"></div>
      <ion-button class="desktop-centered mt-32-desktop" (click)="dismissModal()">{{ t('CLOSE') }}</ion-button>
    </div>
  </ion-content>
</ng-container>
